import React from 'react';
import Slider from 'react-slick';
import {TitleWrap, SecSubTitle, SecTitle, TeamBoxOne} from '../../components';

const TeamOne = ({...restProps})=> {      
  const settings = {
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {          
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {          
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {          
          slidesToShow: 1,
        }
      }
    ]
  };  
  
  return (
    <div {...restProps}>    
      <div className="container">
        <TitleWrap className="text-center">
          <SecSubTitle>Great Team Members</SecSubTitle>
          <SecTitle className="h1">We Have Expert Team</SecTitle>
        </TitleWrap>
        <Slider className="row" {...settings}>
          <TeamBoxOne path="/team-details"
            name="Adekunle James Adeniji"
            desgination="CEO/Software Engineer"
            image="images/team/james-min.png"
          />
          <TeamBoxOne path="/team-details"
            name="Abraham Akintola"
            desgination="CO-CEO/Software Engineer"
            image="images/team/abraham-min.png"
          />
          <TeamBoxOne path="/team-details"
            name="Daniel Olaseinde"
            desgination="UI/UX Designer"
            image="images/team/daniel2.png"
          />
          <TeamBoxOne path="/team-details"
            name="Olamiposi Ajisafe"
            desgination="Business Development"
            image="images/team/olamiposi5.png"
          />
          
        </Slider>
      </div>
    </div>
  );
}

export default TeamOne;